import { render } from "./BrandLogo.vue?vue&type=template&id=afcc504a&scoped=true"
import script from "./BrandLogo.vue?vue&type=script&lang=js"
export * from "./BrandLogo.vue?vue&type=script&lang=js"

import "./BrandLogo.vue?vue&type=style&index=0&id=afcc504a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afcc504a"]])

export default __exports__